import React from 'react'
import Footer from '../components/footer/Footer'
import Navbar from '../components/navigation/Navbar'

function JsCours() {
    return (
        <>
            <Navbar />
            <h1>JavaScript</h1>

            <h2>Outils</h2>
            <p>IDE, Chrome, git</p>


            <Footer />
        </>


    )
}

export default JsCours